import {
  showConfirmationScreen,
  showConfirmationFooterNewsletter,
  tourFormTracking,
  partnerizePixel,
} from "./util";
import { fetchPromoCode, POST } from "../api";
import { loadCalendly } from "./loadCalendly";
import {
  resourceFormSubmission,
  formSubmissionSuccess,
  formContactSubmission,
  formNewsletterSubmission,
} from "../gtm";

import ThankYou from "../thank-you";

export const postSubmitPipe = ($form, mkFormValues, _requestedURL) => {
  const formName = $form.attr("name");
  const isCalendly = $form.hasClass("calendly");
  const isContactUs = $form.hasClass("contact-us-form");

  //  promo code usages need to update the table
  if (mkFormValues.Reference_Code__c) {
    fetchPromoCode(mkFormValues.Reference_Code__c, POST);
  }

  //  resource form needs to trigger the download of the resources
  if (formName === "resourceForm") {
    const linkToDownload = $(".file_to_download").eq(0);
    linkToDownload.find(".trigger").trigger("click");
    resourceFormSubmission();
    showConfirmationScreen(formName);
    return;
  }

  //  gtm and partnerize
  partnerizePixel(mkFormValues.Partnerize_Conversion_ID_App__c);

  formSubmissionSuccess();

  const apiName = formName;
  // string, e.g. 'marketo-submit-success-1842' for the getStarted form
  window?.intellimize?.sendEvent(apiName);

  if (isContactUs) {
    formContactSubmission();
  }

  //  show thank you screen
  if (formName === "newsLetterForm") {
    formNewsletterSubmission();
    showConfirmationFooterNewsletter($form);
    return;
  }

  showConfirmationScreen(formName);

  //  if calendly, then we want to book a tour
  if (isCalendly) {
    const formValueMap = $form.serializeArray().reduce((acc, field) => {
      const { name, value } = field;
      acc[name] = value;
      return acc;
    }, {});

    tourFormTracking(formValueMap.Office_Size2__c);

    loadCalendly($form, formName, formValueMap);
  } else {
    ThankYou.init();
  }
};
